export { Skeleton as default } from '@tiger/bs-comps';
